// token过期处理
export const refreshToken = error => {
  let res = error.response || {}
  let data = res.data
  switch (data.code) {
    case 40300102:
    case 40300103:
    case 40000002:
      window.parent.postMessage(
        JSON.stringify({
          name: 'goback',
        }),
        '*'
      )
      break
    default:
      break
  }
  // return Promise.reject(error)
  throw error
}
